(() => {
  if (window.dvHurttaCampaignExpiry) return;
  window.dvHurttaCampaignExpiry = true;
  const sweep = () => {
    const now = Date.now();
    document.querySelectorAll('[data-hurtta-campaign]').forEach((element) => {
      const endsAt = Date.parse(element.dataset.endsAt);
      if ((!Number.isFinite(endsAt) || now >= endsAt) && !element.hidden) {
        element.hidden = true;
        const fallback = element.nextElementSibling;
        if (fallback?.hasAttribute('data-hurtta-regular-price')) fallback.hidden = false;
        document.dispatchEvent(new Event('dv:hurtta-expired'));
      }
    });
  };
  sweep();
  setInterval(sweep, 1000);
  window.addEventListener('pageshow', sweep);
  document.addEventListener('visibilitychange', sweep);
  new MutationObserver(sweep).observe(document.documentElement, {childList: true, subtree: true});
})();
